export default "__VITE_ASSET__Bff5kcK4__"